// exports a promifsified version which returns a bool

import alertify from "alertifyjs";
import { promisify } from "util";

const alertifyConfirm = promisify((a, label, cb) => {
  const ok = () => cb(false, true);
  const fail = () => cb(false, false);
  alertify.confirm(a, ok, fail).set("labels", label);
});

export default alertifyConfirm;
